import { MAT_RIPPLE_GLOBAL_OPTIONS } from '@angular/material/core';
import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';

const rippleConfig = {
    disabled: true,
};
const rippleConfigFactory = () => {
    console.warn('WARN: xpoRippleConfig is deprecated: Please import the XpoCommonModule instead');
    return rippleConfig;
};
/**
 * @deprecated import the XpoCommonModule instead.
 */
const xpoRippleConfig = {
    provide: MAT_RIPPLE_GLOBAL_OPTIONS,
    useFactory: rippleConfigFactory,
};

const tabsConfig = {
    animationDuration: '0ms',
};

class XpoCommonModule {
}
XpoCommonModule.ɵfac = function XpoCommonModule_Factory(t) { return new (t || XpoCommonModule)(); };
XpoCommonModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoCommonModule });
XpoCommonModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
        { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: rippleConfig },
        { provide: MAT_TABS_CONFIG, useValue: tabsConfig },
    ] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoCommonModule, [{
        type: NgModule,
        args: [{
                providers: [
                    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: rippleConfig },
                    { provide: MAT_TABS_CONFIG, useValue: tabsConfig },
                ],
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoCommonModule, rippleConfig, rippleConfigFactory, tabsConfig, xpoRippleConfig };
